wFormContainer = document.querySelectorAll('.wFormContainer');

if (wFormContainer) {
    wFormContainer.forEach(function (el) {
        el.style.removeProperty('max-width');
        el.classList.remove('wFormContainer');
    });
}
